/**
 * The firm's phone number, for the portal's "contact your accountant" routes. One constant, so the number cannot
 * differ between screens (cp-signing-detail sd-disagree, BR-CP-SB-025). The display form is what the client reads;
 * the tel: form is what a phone dials.
 */
export const FIRM_PHONE_DISPLAY = '(07) 4632 3155';

/** E.164 for a tel: link — no spaces, no brackets. */
export const FIRM_PHONE_TEL = '+61746323155';

/** The tel: href for {@link FIRM_PHONE_TEL}. */
export const FIRM_PHONE_HREF = `tel:${FIRM_PHONE_TEL}`;

/**
 * The firm's public email address and office, as the public site states them (SiteFooter, About, Contact —
 * BR-CP-PUB-004). Used by the Privacy Policy and Terms of Use (Story #29994); the older public pages still write
 * them out inline.
 */
export const FIRM_EMAIL = 'admin@ba-accounting.com.au';

/** The mailto: href for {@link FIRM_EMAIL}. */
export const FIRM_EMAIL_HREF = `mailto:${FIRM_EMAIL}`;

/** The office address on one line. */
export const FIRM_ADDRESS = '105–107 Neil Street, Toowoomba QLD 4350';
